module.exports = __webpack_public_path__ + "img/mingyong15.bdfa9fcd.png";